import admin from './admin.json';
import homepage from './homepage.json';

const pcm = {
    admin,
    homepage
};

export default pcm;